
import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export const SuccessHeader: React.FC = () => {
  return (
    <>
      <div className="flex justify-center mb-4">
        <CheckCircle className="h-16 w-16 text-green-500" />
      </div>
      
      <h1 className="text-2xl font-bold mb-4">Takk for ditt svar!</h1>
      
      <p className="text-gray-600 mb-8">
        Takk for din formidling og bidrag til offentlig samtale og kunnskap.
      </p>
      
      <div className="flex justify-center mb-16">
        <Button 
          asChild
          className="bg-brand-primary hover:bg-brand-primary/90 text-brand-primary-foreground"
        >
          <Link to="/">Tilbake til forsiden</Link>
        </Button>
      </div>
    </>
  );
};
